export const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border',
    md: 'w-6 h-6 border-2',
    lg: 'w-10 h-10 border-2',
    xl: 'w-16 h-16 border-4'
  };

  return (
    <div 
      className={`${sizeClasses[size]} border-white/20 border-t-blue-500 rounded-full animate-spin ${className}`}
      data-testid="loading-spinner"
    />
  );
};

export const PageLoader = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B]">
      <div className="flex flex-col items-center gap-4">
        <LoadingSpinner size="xl" />
        <p className="text-zinc-400 font-medium">Loading...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
